// Import the Mixpanel library
import mixpanel from 'mixpanel-browser';

export const mixPanelTrackNamesOdersV2 = {
  'Click Query Order V2': 'Click Query Order V2',
  'Search Query Order V2': 'Search Query Order V2',
  'Click Item Serch Order V2': 'Click Item Serch Order V2',
  'Close Items Select Orders V2': 'Close Items Select Orders V2',
};

class ProductTracking {
  constructor(projectToken: string) {
    // Initialize Mixpanel with the provided project token
    // console.log('MIXPANEL:INIT', projectToken);
    try {
      mixpanel.init(projectToken, { track_pageview: false });
    } catch (err) {
      // console.error('MIXPANEL:INIT', err);
    }
  }

  track(event: string, params?: Record<string, any>): void {
    try {
      mixpanel.track(event, params);
    } catch (err) {
      console.error('MIXPANEL:TRACK', err);
    }
  }

  trackSignIn(params: { userEmail: string }): void {
    const { userEmail } = params;
    this.track('Click Sign In Button', {
      userEmail: userEmail,
    });
  }

  trackAuth(params: { userEmail: string; sellerGroupName: string }): void {
    const { userEmail, sellerGroupName } = params;
    try {
      mixpanel.identify(userEmail);
      mixpanel.people.set({
        Email: userEmail,
        SellerGroupName: sellerGroupName,
      });
      mixpanel.register({
        seller_group_name: sellerGroupName,
      });
    } catch (err) {
      console.error('MIXPANEL:TRACK', err);
    }
  }

  // Event: Create Order
  trackCreateOrder(params: {
    sellerTradingName: string;
    orderType?: string;
    orderCreationOrigin: string;
  }): void {
    // const { sellerTradingName, orderType, orderCreationOrigin } = params;
    // this.track('Finish Create Order', {
    //   sellerTradingName: sellerTradingName,
    //   orderType: orderType,
    //   orderCreationOrigin: orderCreationOrigin,
    // });
  }

  trackOpenCreateOrderPopup({ origin }: { origin: string }): void {
    // this.track('Open Create Order Popup', { origin });
  }

  trackOpenRequestPickupPopup({ origin }: { origin: string }): void {
    // this.track('Open Request Pickup Popup', { origin });
  }

  trackFinishRequestPickup({
    ordersCount,
    sellerTradingName,
  }: {
    ordersCount: number;
    sellerTradingName?: string;
  }): void {
    this.track('Finish Request Pickup', {
      ordersCount: ordersCount,
      sellerTradingName: sellerTradingName,
    });
  }

  trackFinishOneOrderPickup({
    sellerTradingName,
  }: {
    sellerTradingName: string;
  }): void {
    this.track('Finish One Order Pickup', { sellerTradingName });
  }

  trackOpenQuoteFreightPopup(): void {
    // this.track('Open Quote Freight Popup');
  }

  trackFinishQuoteFreight(): void {
    // this.track('Finish Quote Freight');
  }

  trackOpenOrderDetailsSidePanel(): void {
    // this.track('Open Order Details Side Panel');
  }

  trackCloseOrderDetailsSidePanel(): void {
    // this.track('Close Order Details Side Panel');
  }

  trackCancelDelivery({
    carrierName,
    sellerTradingName,
  }: {
    carrierName: string;
    sellerTradingName?: string;
  }): void {
    // this.track('Cancel Delivery', { carrierName, sellerTradingName });
  }

  trackPreviewRoute({ ordersCount }: { ordersCount: number }): void {
    // this.track('Preview Route', { ordersCount });
  }

  trackOpenCreateRoutePopup(): void {
    // this.track('Open Create Route Popup');
  }

  trackPrivateFleetCreateRoute({ ordersCount }: { ordersCount: number }): void {
    // this.track('Create Private Fleet Route', { ordersCount }); // TODO: Remove this
  }

  trackCarrierCreateRoute({ ordersCount }: { ordersCount: number }): void {
    // this.track('Create Carrier Route', { ordersCount }); // TODO: Remove this
  }

  trackCreateRouteSuggestions({ ordersCount }: { ordersCount: number }): void {
    // this.track('Create Route Suggestions', { ordersCount }); // TODO: Remove this
  }

  trackExportOrders({
    type,
    origin,
  }: {
    type: 'csv' | 'json' | 'pdf';
    origin: string;
  }): void {
    this.track('Export Orders', { type, origin });
  }

  trackManualHandle({ ordersCount }: { ordersCount: number }): void {
    // this.track('Manual Handle', { ordersCount });
  }

  trackOpenReportCreatePopup(): void {
    // this.track('Open Report Create Popup');
  }

  trackCloseReportCreatePopup(): void {
    // this.track('Close Report Create Popup');
  }

  trackCreateReport({
    reportType,
    reportFormat,
    rangeDate,
    sellerIds,
    duration,
  }: {
    reportType: string;
    reportFormat: string;
    rangeDate: number;
    sellerIds: string[];
    duration: string;
  }): void {
    // this.track('Finish Create Report', {
    //   reportType,
    //   reportFormat,
    //   rangeDate,
    //   sellerIds,
    //   duration,
    // });
  }

  trackDownloadReport({
    reportType,
    reportFormat,
  }: {
    reportType: string;
    reportFormat: string;
  }): void {
    this.track('Download Report', { reportType, reportFormat });
  }

  trackOpenSellerCreatePopup(): void {
    // this.track('Open Seller Create Popup');
  }

  trackCloseSellerCreatePopup(): void {
    // this.track('Close Seller Create Popup');
  }

  trackCreateSeller(): void {
    // this.track('Finish Create Seller');
  }

  trackKpiFilterAdd({ status }: { status: string }): void {
    // this.track('KPI-ADD', { status });
  }

  trackKpiFilterRemove({ status }: { status: string }): void {
    // this.track('KPI-REMOVE', { status });
  }

  trackKpiFilterAll({ status }: { status: string }): void {
    // this.track('KPI-ALL', { status });
  }

  trackKpiFilterOnly({ status }: { status: string }): void {
    // this.track('KPI-ONLY', { status });
  }

  openManualStatusPopup({ status }: { status: string }): void {
    // this.track('Open Manual Status Popup', { status });
  }

  finishManualStatusPopup({ status }: { status: string }): void {
    // this.track('Finish Manual Status Popup', { status });
  }

  closeManualStatusPopup({ status }: { status: string }) {
    // this.track('Close Manual Status Popup', { status });
  }

  openDuplicateOrderPopup({ status }: { status: string }): void {
    // this.track('Open Duplicate Order Popup', { status });
  }

  finishDuplicateOrderPopup({ status }: { status: string }): void {
    // this.track('Finish Duplicate Order Popup', { status });
  }

  closeDuplicateOrderPopup({ status }: { status: string }) {
    // this.track('Close Duplicate Order Popup', { status });
  }

  openUploadReceiptPopup({ status }: { status: string }): void {
    // this.track('Open Upload Receipt Popup', { status });
  }

  finishUploadReceiptPopup({ status }: { status: string }): void {
    // this.track('Finish Upload Receipt Popup', { status });
  }

  closeUploadReceiptPopup({ status }: { status: string }) {
    // this.track('Close Upload Receipt Popup', { status });
  }

  createFinishCarrierIntegration({ carrierName }: { carrierName: string }) {
    this.track('Finish Create Carrier Integration', { carrierName });
  }

  createOpenCarrierIntegration() {
    this.track('Create Open Carrier Integration');
  }

  duplicateFinishCarrierIntegration({ carrierName }: { carrierName: string }) {
    this.track('Duplicate Finish Carrier Integration', { carrierName });
  }

  duplicateOpenCarrierIntegration() {
    this.track('Duplicate Open Carrier Integration');
  }

  editFinishCarrierIntegration({
    carrierName,
    edited,
  }: {
    carrierName: string;
    edited: boolean;
  }) {
    this.track('Edit Finish Carrier Integration', {
      carrierName,
      edited,
    });
  }

  createFinishOrderIntegration({
    orderIntegrationName,
  }: {
    orderIntegrationName: string;
  }) {
    this.track('Finish Create Order Integration', {
      orderIntegrationName,
    });
  }

  createOpenOrderIntegration() {
    this.track('Create Open Order Integration');
  }

  duplicateFinishOrderIntegration({
    orderIntegrationName,
  }: {
    orderIntegrationName: string;
  }) {
    this.track('Duplicate Finish Order Integration', {
      orderIntegrationName,
    });
  }

  duplicateOpenOrderIntegration() {
    this.track('Duplicate Open Order Integration');
  }

  editFinishOrderIntegration({
    orderIntegrationName,
    edited,
  }: {
    orderIntegrationName: string;
    edited: boolean;
  }) {
    this.track('Edit Finish Order Integration', {
      orderIntegrationName,
      edited,
    });
  }

  editAutoCompleteTemplateOrderIntegration({
    orderIntegrationName,
  }: {
    orderIntegrationName: string;
  }) {
    this.track('Edit Auto Complete Template Order Integration', {
      orderIntegrationName,
    });
  }

  editSellerData({
    sellerTradingName,
    edited,
  }: {
    sellerTradingName: string;
    edited: boolean;
  }) {
    // this.track('Edit Seller Data', { sellerTradingName, edited });
  }

  editSellerAddress({
    provider,
    edited,
  }: {
    provider: string;
    edited: boolean;
  }) {
    // this.track('Edit Seller Address', { provider, edited });
  }

  clickQueryOrderV1() {
    // this.track('Click Query Order V1');
  }

  searchQueryOrderV1({
    numbersOrders,
    duration,
  }: {
    numbersOrders: number;
    duration: string;
  }) {
    // this.track('Search Query Order V1', {
    //   numbersOrders,
    //   duration,
    // });
  }

  clickQueryOrderV2() {
    // this.track(mixPanelTrackNamesOdersV2['Click Query Order V2']);
  }

  searchQueryOrderV2({
    numbersOrders,
    duration,
  }: {
    numbersOrders: number;
    duration: string;
  }) {
    //  this.track(mixPanelTrackNamesOdersV2['Search Query Order V2'], {
    //   numbersOrders,
    //   duration,
    // });
  }

  clickItemSerchOrderV2({ createdAt }: { createdAt: string }) {
    // this.track(mixPanelTrackNamesOdersV2['Click Item Serch Order V2'], {
    //   createdAt,
    // });
  }

  closeItemsSelectOrdersV2() {
    // this.track(mixPanelTrackNamesOdersV2['Close Items Select Orders V2']);
  }

  editOrderCostumer(isEddited: boolean) {
    // this.track('Edit Order Costumer', { isEddited });
  }

  editOrderAddress(isEddited: boolean) {
    // this.track('Edit Order Address', { isEddited });
  }

  atributteDriverRouteV2() {
    // this.track('Atributte Driver Route V2');
  }

  atributeToTRPRouteV2() {
    // this.track('Atribute to TRP Route V2');
  }

  duplicateRouteV2() {
    // this.track('Duplicate Route V2');
  }

  editManualStatusValues(editedValues: object) {
    // this.track('Edit Manual Status Values', editedValues);
  }

  openRightSidebarOrders(): void {
    this.track('Open Right Sidebar Orders');
  }

  openRightSidebarDeliveries(): void {
    this.track('Open Right Sidebar Deliveries');
  }

  openRightSidebarCsat(): void {
    this.track('Open Right Sidebar Csat');
  }

  closeRightSidebarOrders(): void {
    this.track('Close Right Sidebar Orders');
  }

  closeRightSidebarDeliveries(): void {
    this.track('Close Right Sidebar Deliveries');
  }

  closeRightSidebarCsat(): void {
    this.track('Close Right Sidebar Csat');
  }

  openCreateDispatchRule(): void {
    this.track('open_create_dispatch_rule');
  }

  finishCreateDispatchRule(): void {
    this.track('finish_create_dispatch_rule');
  }

  closeCreateDispatchRule(): void {
    this.track('close_create_dispatch_rule');
  }

  openActivateDispatchRule(): void {
    this.track('open_activate_dispatch_rule');
  }

  finishActivateDispatchRule(): void {
    this.track('finish_activate_dispatch_rule');
  }

  closeActivateDispatchRule(): void {
    this.track('close_activate_dispatch_rule');
  }

  openDuplicateDispatchRule(): void {
    this.track('open_duplicate_dispatch_rule');
  }

  finishDuplicateDispatchRule(): void {
    this.track('finish_duplicate_dispatch_rule');
  }

  closeDuplicateDispatchRule(): void {
    this.track('close_duplicate_dispatch_rule');
  }

  openDeleteDispatchRule(): void {
    this.track('open_delete_dispatch_rule');
  }

  finishDeleteDispatchRule(): void {
    this.track('finish_delete_dispatch_rule');
  }

  closeDeleteDispatchRule(): void {
    this.track('close_delete_dispatch_rule');
  }

  openEditDispatchRule(): void {
    this.track('open_edit_dispatch_rule');
  }

  finishEditDispatchRule(): void {
    this.track('finish_edit_dispatch_rule');
  }

  closeEditDispatchRule(): void {
    this.track('close_edit_dispatch_rule');
  }

  openCreateResendRule(): void {
    this.track('open_create_resend_rule');
  }

  finishCreateResendRule(): void {
    this.track('finish_create_resend_rule');
  }

  closeCreateResendRule(): void {
    this.track('close_create_resend_rule');
  }

  openActivateResendRule(): void {
    this.track('open_activate_resend_rule');
  }

  finishActivateResendRule(): void {
    this.track('finish_activate_resend_rule');
  }

  closeActivateResendRule(): void {
    this.track('close_activate_resend_rule');
  }

  openDuplicateResendRule(): void {
    this.track('open_duplicate_resend_rule');
  }

  finishDuplicateResendRule(): void {
    this.track('finish_duplicate_resend_rule');
  }

  closeDuplicateResendRule(): void {
    this.track('close_duplicate_resend_rule');
  }

  openDeleteResendRule(): void {
    this.track('open_delete_resend_rule');
  }

  finishDeleteResendRule(): void {
    this.track('finish_delete_resend_rule');
  }

  closeDeleteResendRule(): void {
    this.track('close_delete_resend_rule');
  }

  openEditResendRule(): void {
    this.track('open_edit_resend_rule');
  }

  finishEditResendRule(): void {
    this.track('finish_edit_resend_rule');
  }

  closeEditResendRule(): void {
    this.track('close_edit_resend_rule');
  }

  openCreateInactivityRule(): void {
    this.track('open_create_inactivity_rule');
  }

  finishCreateInactivityRule(): void {
    this.track('finish_create_inactivity_rule');
  }

  closeCreateInactivityRule(): void {
    this.track('close_create_inactivity_rule');
  }

  openActivateInactivityRule(): void {
    this.track('open_activate_inactivity_rule');
  }

  finishActivateInactivityRule(): void {
    this.track('finish_activate_inactivity_rule');
  }

  closeActivateInactivityRule(): void {
    this.track('close_activate_inactivity_rule');
  }

  openDuplicateInactivityRule(): void {
    this.track('open_duplicate_inactivity_rule');
  }

  finishDuplicateInactivityRule(): void {
    this.track('finish_duplicate_inactivity_rule');
  }

  closeDuplicateInactivityRule(): void {
    this.track('close_duplicate_inactivity_rule');
  }

  openDeleteInactivityRule(): void {
    this.track('open_delete_inactivity_rule');
  }

  finishDeleteInactivityRule(): void {
    this.track('finish_delete_inactivity_rule');
  }

  closeDeleteInactivityRule(): void {
    this.track('close_delete_inactivity_rule');
  }

  openEditInactivityRule(): void {
    this.track('open_edit_inactivity_rule');
  }

  finishEditInactivityRule(): void {
    this.track('finish_edit_inactivity_rule');
  }

  closeEditInactivityRule(): void {
    this.track('close_edit_inactivity_rule');
  }

  trackOrdersQueryDateRange({ dateRange }: { dateRange: number }): void {
    this.track('orders_query_date_range', { dateRange });
  }
  trackOrdersFilterDateRange({ dateRange }: { dateRange: number }): void {
    this.track('orders_filter_date_range', { dateRange });
  }
  trackLivemodeToggle({ enabled }: { enabled: boolean }): void {
    this.track('orders_livemode_toggle', { enabled });
  }
}

// Example usage
const NX_MIXPANEL_PROJECT_TOKEN = process.env['NX_MIXPANEL_PROJECT_TOKEN'];

export const productTracker = new ProductTracking(NX_MIXPANEL_PROJECT_TOKEN!);
